import { useLocation } from 'react-router';

import { Seo, StatusState } from '@/components/molecules';
import { ImportPromiseBand, PageIntro, Section } from '@/components/organisms';

import { SubmittedDetails } from '../checkout/organisms/SubmittedDetails';

export default function AccessorySubmittedPage() {
  const { state } = useLocation();
  const reference = (state as { reference?: string } | null)?.reference ?? null;

  return (
    <>
      <Seo
        title="Request received"
        description="Your accessory order request has been received."
        path="/accessories/submitted"
        noindex
      />
      {reference ? (
        <>
          <PageIntro
            eyebrow="Request received"
            title="Thank you — we have your request"
            lede="Our team will review the parts you selected and send you an order quotation."
            keepOnPhone
          />
          <Section sx={{ py: { xs: 10, md: 16 } }}>
            <SubmittedDetails reference={reference} />
          </Section>
        </>
      ) : (
        <StatusState
          tone="empty"
          headingLevel="h1"
          title="Nothing to show here"
          description="This page confirms an order request. Browse the accessories we stock to start one."
          action={{ label: 'Browse accessories', to: '/accessories' }}
        />
      )}
      <ImportPromiseBand />
    </>
  );
}